import "./Common.scss";
import CardTitle from "./CardTitle";

const Card = ({children, id, color, padding, ifCond = true, title = null}) => {
  if (!ifCond) {
    return null;
  }

  const classNames = [];

  if (color) {
    classNames.push("cust-color-" + color + "-border-left");
  }

  if (padding) {
    classNames.push("padding");
  }

  return (
    <>
      {title && <CardTitle title={title}/>}

      <div id={id} className="card app-card">
        <div id={id ? id + "-content" : null} className={classNames.join(" ")}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Card;
